import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'

import 'jquery/dist/jquery.min.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import './Bootstrap.scss'

import P_Home from './pages/Home/Home'
import P_Portfolio from './pages/Portfolio/Portfolio'
import P_Error from './pages/Error/Error'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
  <>
    <Router>
      <Routes>
        <Route path='/' element={<P_Home />} />
        <Route path='/Home' element={<P_Home />} />
        <Route path='/Portfolio' element={<P_Portfolio />} />
        <Route path='*' element={<P_Error />} />
      </Routes>
    </Router>
  </>,
  //</React.StrictMode>
)

reportWebVitals()
